import React from "react";

import { formatBusinessSizes } from "../../../util/format.js";

export default function ContractHoldersListItem({ contractHolder }) {
  return (
    <tr role="row">
      <th role="rowheader">
        <a
          href={`#/detail/${contractHolder.chInfoSeq}`}
          title={`Go to the detail page for ${contractHolder.displayName}`}
        >
          {contractHolder.companyName} ({contractHolder.displayName})
        </a>
      </th>
      <td className="text-center" style={{ whiteSpace: "pre" }} role="gridcell">
        {contractHolder.sewpContractNumber}
      </td>
      <td className="text-center" style={{ whiteSpace: "pre" }} role="gridcell">
        {contractHolder.setAside}
      </td>
      <td className="text-center" role="gridcell">
        {formatBusinessSizes(contractHolder.businessSizes)}
      </td>
    </tr>
  );
}
